export function ContentHeadline({As, text}) {
  return (
    <As className="content__headline">{text}</As>
  )
}